'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

/**
 * Detects Supabase auth error params in the URL hash (e.g. #error=access_denied&error_code=otp_expired)
 * and redirects to the /auth-error page so users see a proper error screen
 * instead of silently landing on the homepage with a broken URL.
 */
export default function AuthErrorRedirect() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const hash = window.location?.hash;
    if (!hash) return;

    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const error = params?.get('error');
    const errorCode = params?.get('error_code');

    if (error || errorCode) {
      // Preserve the error params so the auth-error page can read them
      router?.replace(`/auth-error${hash}`);
    }
  }, [router]);

  return null;
}
